var _mask, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNftLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 32,
    viewBox: "0 0 60 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_179_325",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 32,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 60,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59 3C59 1.89543 58.1046 1 57 1H3C1.89543 1 1 1.89543 1 3V29C1 30.1046 1.89543 31 3 31H53.1716C53.702 31 54.2107 30.7893 54.5858 30.4142L58.4142 26.5858C58.7893 26.2107 59 25.702 59 25.1716V3Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59 3C59 1.89543 58.1046 1 57 1H3C1.89543 1 1 1.89543 1 3V29C1 30.1046 1.89543 31 3 31H53.1716C53.702 31 54.2107 30.7893 54.5858 30.4142L58.4142 26.5858C58.7893 26.2107 59 25.702 59 25.1716V3Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 2H57V0H3V2ZM2 29V3H0V29H2ZM53.1716 30H3V32H53.1716V30ZM57.7071 25.8787L53.8787 29.7071L55.2929 31.1213L59.1213 27.2929L57.7071 25.8787ZM58 3V25.1716H60V3H58ZM59.1213 27.2929C59.6839 26.7303 60 25.9672 60 25.1716H58C58 25.4368 57.8946 25.6911 57.7071 25.8787L59.1213 27.2929ZM53.1716 32C53.9672 32 54.7303 31.6839 55.2929 31.1213L53.8787 29.7071C53.6911 29.8946 53.4368 30 53.1716 30V32ZM0 29C0 30.6569 1.34314 32 3 32V30C2.44771 30 2 29.5523 2 29H0ZM57 2C57.5523 2 58 2.44772 58 3H60C60 1.34315 58.6569 0 57 0V2ZM3 0C1.34315 0 0 1.34315 0 3H2C2 2.44772 2.44772 2 3 2V0Z",
    fill: "white",
    mask: "url(#path-1-outside-1_179_325)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 3C1 1.89543 1.89543 1 3 1H5.16667V31H3C1.89543 31 1 30.1046 1 29V3Z",
    fill: "#FDBC0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftLabel);
export default __webpack_public_path__ + "static/media/nftLabel.25f0cb906922f1595972f19e06fef484.svg";
export { ForwardRef as ReactComponent };